eshopApp.controller('CategoryProductsController', ['$scope', '$http', '$uibModal', 'alertMessage', function($scope, $http, $uibModal, alertMessage) {

	// Helpers
	$scope.helper = CustomNameSpace.helpers;

	$scope.add_in_progress = [];
	$scope.products = {};
    $scope.instanceCategoryId = null;

	// Sorting texts
	var str_name_asc = angular.element('#m_categoryproducts_str_name_asc').text();
	var str_name_desc = angular.element('#m_categoryproducts_str_name_desc').text();
	var str_price_asc = angular.element('#m_categoryproducts_str_price_asc').text();
	var str_price_desc = angular.element('#m_categoryproducts_str_price_desc').text();

	// Sorting options
	$scope.data = {
		availableOptions: [
			{ sorting: 'name|asc', name: str_name_asc },
			{ sorting: 'name|desc', name: str_name_desc },
			{ sorting: 'price|asc', name: str_price_asc },
			{ sorting: 'price|desc', name: str_price_desc },
		],
		availableLimits: ['20', '40', '60', '100'],
		selectedOption: { sorting: 'name|asc' },
		selectedLimit: '20',
	};

	// Sorting defaults
	$scope.order = 'priority';
	$scope.sort = 'desc';
	$scope.limit = '100';
	$scope.page = '1';
	$scope.search = '';

	/*$scope.category_id = angular.element('.module_categoryproducts #category_id').text();
	if (!$scope.category_id) {
		console.log('No category ID set in #category_id');
	}*/

	// Get products
	$scope.fetch = function() {

		$scope.spinner = true;

		$http.get('/m/products/category/' + $scope.$parent.selectedCategoryId, {
			params: {
				order: $scope.order,
				sort: $scope.sort,
				limit: $scope.limit,
				page: $scope.page,
				search: $scope.search,
			}
		}).success(function(response){
			$scope.products[$scope.$parent.selectedCategoryId] = response;
	  	}).error(function(){
	  		//alertMessage.set(generic.error, 'error');
	  	}).finally(function(){
	  		$scope.spinner = false;
	  	});
	};

    // Fetch Product when selected Category ID changes in parent scope
    $scope.$watch('$parent.selectedCategoryId', function(value) {
        // Make sure to only call the function for the selected instance
        if (value && value == $scope.instanceCategoryId) {
            $scope.fetch(); // Get Products
        }
    });

	// Update parameters and call fetch
	$scope.updateProducts = function(page, type) {

		if (!page) {
			page = 1;
		}

		if (type == 'pagination') {
			if (page == $scope.products[$scope.$parent.selectedCategoryId].current_page || page > $scope.products[$scope.$parent.selectedCategoryId].last_page) {
				return false;
			}
		}

		/*var sorting_split = $scope.data.selectedOption.sorting.split('|');
		$scope.order = sorting_split[0];
		$scope.sort = sorting_split[1];
		$scope.limit = $scope.data.selectedLimit;*/

		$scope.page = page;

		$scope.fetch();
	};

	// Add to cart
	$scope.addToCart = function(product_id, qty){
		$scope.add_in_progress[product_id] = true;

		$http.post('/a/add_to_cart', {
			product_id : product_id,
			qty : qty
		}).success(function(response){
			if (response.message === 'added') {
				alertMessage.set(response.alert, 'success');
			} else {
				alertMessage.set(generic.error, 'error');
			}
			if (response.stock_is_not_enough) {
				// DevPro3 stock is not enough -> warn user
				alertMessage.set('Tuotteen varastosaldo ylittyi!', 'warning');
			}
	  	}).error(function() {
	  		alertMessage.set(generic.error, 'error');
	  	}).finally(function(){
	  		$scope.add_in_progress[product_id] = false;
	  	});
	};

	// Make reservation
	$scope.makeReservation = function(product_id, qty){
		if (confirm(generic.confirm)) {
			$scope.reservation_in_progress = true;

			$http.post('/a/make_product_reservation', {
				product_id : product_id,
				qty : qty
			}).success(function(response){
				if (response.message === 'added') {
					alertMessage.set(response.alert, 'success');
				} else {
					alertMessage.set(generic.error, 'error');
				}
		  	}).error(function(response) {
		  		alertMessage.set(generic.error, 'error');
		  	}).finally(function(){
		  		$scope.reservation_in_progress = false;
		  	});
	  	}
	};

	// Pagination range
	$scope.range = function(count){
		if ($scope.products[$scope.$parent.selectedCategoryId]) {
			var curr_page = parseInt($scope.page);
			var last_page = parseInt($scope.products[$scope.$parent.selectedCategoryId].last_page);
			var limit = 10;

			return $scope.helper.paginationRange(limit, count, curr_page, last_page); // helper function in main.js
		}
	};

	// Product quick view
	/*$scope.quickViewQty = 1;
	$scope.selectedProduct = null;
	$scope.quickView = function(product_id) {
		$scope.quickViewQty = 1;
		for(var key in $scope.products.data) {
			if ($scope.products.data[key].id == product_id) {
				$scope.selectedProduct = $scope.products.data[key];
				break;
			}
		}
		var modalInstance = $uibModal.open({
			scope: $scope,
			templateUrl: 'cpquickview.html',
			size: 'lg',
		});
	};*/

}]);
